// import React from 'react';

// const Hero = () => {
//   return (
//     <section className="bg-light py-16 px-8 text-center">
//       <h1 className="text-4xl font-bold text-primary mb-4">Connect with Verified Packers and Movers</h1>
//       <p className="text-dark mb-6 max-w-2xl mx-auto">
//         Submit your shifting request and get contacted by professionals from your city. Secure. Fast. Trusted.
//       </p>
//       <button className="bg-secondary text-white px-6 py-2 rounded hover:bg-accent transition">
//         Get Free Quotes
//       </button>
//     </section>
//   );
// };

// export default Hero;

import React from "react";
import starlinkImg from "../assets/starlink.jpg"; // Import the image

const Hero = () => {
  return (
    <section
      className="relative bg-light bg-cover bg-center bg-no-repeat py-16 px-8 text-center"
      style={{
        backgroundImage: `url(${starlinkImg})`,
      }}
    >
      <div className="absolute inset-0 bg-black/40 z-0" />
      <div className="relative z-10">
        <h1 className="text-4xl font-bold text-white mb-2">
          Top Logistics Companies in India, Compare Charges and Quotes Save Up
          to 25%
        </h1>
        <p className="text-white mb-4">
          Book Reliable Logistics Services for Transportation and Shifting.
        </p>

        <div className="bg-primary text-white p-6 rounded-lg w-full max-w-4xl mx-auto mt-8">
          <div className="flex flex-col md:flex-row gap-4">
            <input
              className="p-2 rounded text-black flex-1"
              placeholder="City From"
            />
            <input
              className="p-2 rounded text-black flex-1"
              placeholder="City To"
            />
            <select className="p-2 rounded text-black flex-1">
              <option>-- Select Services --</option>
              <option>Packers & Movers</option>
              <option>Car Transport</option>
              <option>Warehouse</option>
              <option>Cargo & Freight</option>
              <option>Bike Transport</option>
              <option>Pet Relocation</option>
              <option>International Movers</option>
            </select>
            <select className="p-2 rounded text-black flex-1">
              <option>-- Select Subservice --</option>
            </select>
          </div>
          <button className="bg-secondary text-white px-6 py-2 rounded mt-4 hover:bg-accent transition">
            Next
          </button>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 px-6">
          <div className="bg-white text-primary p-4 shadow rounded">
            <p className="text-2xl font-bold">1500 +</p>
            <p>DAILY HAPPY CUSTOMERS</p>
          </div>
          <div className="bg-white text-primary p-4 shadow rounded">
            <p className="text-2xl font-bold">6387 +</p>
            <p>VERIFIED SERVICE PROVIDERS</p>
          </div>
          <div className="bg-white text-primary p-4 shadow rounded">
            <p className="text-2xl font-bold">4.7/5</p>
            <p>AVERAGE RATING</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
